import { mapActions } from 'vuex';

export default {
  data() {
    return {
      durasi: null,
      keys: {
        1: ['dasar', 'kontak', 'diklat', 'organisasi', 'program', 'prestasi', 'komunitas', 'hobi', 'dokumen'],
      },
      contents: {
        dasar: {
          component: 'Info',
          form: 'FormInput',
          title: 'Informasi Umum',
          status: 'profil',
          optional: false,
        },
        diklat: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Pengalaman Mengikuti Pelatihan',
          status: 'diklat',
          deskripsi:
            'Tuliskan maksimal 10 (sepuluh) pelatihan yang relevan dengan profesi anda yang pernah anda ikuti selama 3 tahun terakhir',
          max: 10,
          optional: true,
        },
        organisasi: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Pengalaman Berorganisasi',
          status: 'organisasi',
          deskripsi: 'Tuliskan maksimal 5 (lima) pengalaman berorganisasi Anda',
          max: 5,
          optional: true,
        },
        program: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Pengalaman Menjalankan Program Linstas Instansi',
          status: 'program',
          deskripsi:
            'Tuliskan maksimal 5 (lima) pengalaman Anda menjalankan program/ kerja sama antara Satuan Pendidikan yang Anda pimpin dengan instansi/ organisasi lain dalam 4 tahun terakhir',
          max: 5,
          optional: true,
        },
        prestasi: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Prestasi',
          status: 'prestasi',
          deskripsi:
            'Tuliskan pengalaman prestasi yang pernah Anda (bukan prestasi Satuan Pendidikan yang Anda Pimpin) raih dalam kurun waktu 5 tahun terakhir',
          max: 5,
          optional: true,
        },
        komunitas: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Keterlibatan Dalam Kegiatan Komunitas Masyarakat',
          status: 'komunitas',
          deskripsi:
            'Tuliskan maksimal 5 (lima) keterlibatan Anda dalam kegiatan komunitas masyarakat yang Anda ikuti dalam kurun waktu 3 tahun terakhir',
          max: 5,
          optional: true,
        },
        hobi: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Hobi',
          status: 'hobi',
          deskripsi: 'Tuliskan hobi yang Anda tekuni dalam mengisi waktu luang',
          max: 5,
          optional: true,
        },
        kontak: {
          component: 'Daftar',
          form: 'FormCollection',
          title: 'Nomor Kontak Lain',
          deskripsi:
            'Tuliskan <strong>maksimal 2 nomor kontak keluarga/rekan</strong> yang dapat dihubungi jika nomor kontak ' +
            'Anda tidak dapat dihubungi atau dalam situasi darurat',
          status: 'kontak',
          max: 2,
        },
        dokumen: {
          component: 'Daftar',
          form: 'FormUnggah',
          title: 'Dokumen Penting',
          status: 'berkas',
          deskripsi: '',
          optional: false,
        },
      },
    };
  },
  computed: {
    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        dasar: {
          ptk: {
            selector: ['k_propinsi', 'k_kota'],
            required: ['k_propinsi', 'k_kota'],
            label: ['Provinsi Domisili', 'Kota/Kabupaten Domisili'],
            options: [M_PROPINSI, M_KOTA],
            grid: [{ cols: 6 }, { cols: 6 }],
          },
          dapodik: {
            selector: ['k_propinsi_dapodik', 'k_kota_dapodik'],
            required: [false, false],
            label: ['Provinsi KTP (Dapodik)', 'Kota/Kabupaten KTP (Dapodik)'],
            options: [M_PROPINSI, M_KOTA],
            disabled: [true, true],
            grid: [{ cols: 6 }, { cols: 6 }],
          },
          sekolah_dapodik: {
            selector: ['k_propinsi_sekolah_dapodik', 'k_kota_sekolah_dapodik'],
            required: [false, false],
            label: ['Provinsi Sekolah (Dapodik)', 'Kota/Kabupaten Sekolah (Dapodik)'],
            options: [M_PROPINSI, M_KOTA],
            disabled: [true, true],
            grid: [{ cols: 6 }, { cols: 6 }],
          },
        },
        ajar: {
          selector: ['k_propinsi', 'k_kota'],
          required: ['k_propinsi', 'k_kota'],
          label: ['Provinsi', 'Kota/Kabupaten'],
          disabled: [true, true],
          options: [M_PROPINSI, M_KOTA],
          grid: [{ cols: 6 }, { cols: 6 }],
        },
      };
    },

    items() {
      let result = [];
      for (const key of this.keys[1] || []) {
        if (this.contents[key] || this[key]) {
          const temp = Object.assign({ id: key }, this.contents[key] || this[key] || {});
          result.push(temp);
        }
      }

      return result;
    },

    info() {
      return {
        dasar: [
          [
            {
              key: 'nama',
              label: 'Nama',
              value: this.$getDeepObj(this.profil, 'ptk.data.nama') || '-',
            },
            {
              key: 'no_ukg',
              label: 'Nomor UKG',
              value: this.$getDeepObj(this.profil, 'ptk.data.no_ukg') || '-',
            },
          ],
          [
            {
              key: 'nik',
              label: 'NIK (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'nik') || '-',
            },
          ],
          [
            {
              key: 'no_wa',
              label: 'Nomor Telepon (terhubung WhatsApp)',
              value: this.$getDeepObj(this.profil, 'no_wa') || '-',
            },
            {
              key: 'email',
              label: 'Surel (untuk Kontak)',
              value: this.$getDeepObj(this.profil, 'ptk.data.alt_email') || '-',
            },
          ],
          [
            {
              key: 'tmp_lahir',
              label: 'Tempat Lahir',
              value: this.$getDeepObj(this.profil, 'ptk.data.tmp_lahir') || '-',
            },
            {
              key: 'tgl_lahir',
              label: 'Tanggal Lahir',
              value: this.$localDate(this.$getDeepObj(this.profil, 'ptk.data.tgl_lahir') || '-'),
            },
          ],
          [
            {
              key: 'k_propinsi',
              label: 'Provinsi KTP (Dapodik)',
              value: this.$getDeepObj(this.profil, 'ptk.data.m_propinsi.data.keterangan') || '-',
            },
            {
              key: 'k_kota',
              label: 'Kota/Kabupaten KTP (Dapodik)',
              value: this.$getDeepObj(this.profil, 'ptk.data.m_kota.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'alamat',
              label: 'Alamat KTP (Dapodik)',
              value: this.$getDeepObj(this.profil, 'ptk.data.ptk_info_dapodik.data.alamat_jalan') || '-',
              size: 12,
            },
          ],
          [
            {
              key: 'k_propinsi',
              label: 'Provinsi Domisili',
              value: this.$getDeepObj(this.profil, 'm_propinsi.data.keterangan') || '-',
            },
            {
              key: 'k_kota',
              label: 'Kota/Kabupaten Domisili',
              value: this.$getDeepObj(this.profil, 'm_kota.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'alamat',
              label: 'Alamat KTP Domilisi',
              value: this.$getDeepObj(this.profil, 'alamat') || '-',
              size: 12,
            },
          ],
          [
            {
              key: 'sekolah_id',
              label: 'Satminkal',
              value: `
              ${this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.nama')}
              (${this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.npsn')})
              `,
            },
            {
              key: 'jenjang',
              label: 'Jenjang',
              value: this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.m_jenjang.data.singkat'),
            },
          ],
          [
            {
              key: 'tugas',
              label: 'Tugas Tambahan',
              value: [
                this.$getDeepObj(this.profil, 'm_tugas.data.keterangan'),
                `
                ${this.$getDeepObj(this.profil, 'sekolah.data.nama')} 
                (${this.$getDeepObj(this.profil, 'sekolah.data.npsn')})
                `,
              ].join(' pada '),
            },
            {
              key: 'periode',
              label: 'Periode Tugas Tambahan',
              value: [
                this.$localDate(this.$getDeepObj(this.kasek, 'tmt_tambahan')),
                `(${this.$getDeepObj(this.kasek, 'periode_tambahan') || '-'})`,
              ].join(' '),
            },
          ],
          [
            {
              key: 'k_kasek_lama_psp',
              label: 'Lama menjabat sebagai Kepala Satuan Pendidikan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_kasek_lama.data.keterangan') || '-',
            },
            {
              key: 'k_kasek_sisa_psp',
              label: 'Sisa masa tugas sebagai kepala satuan pendidikan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_kasek_sisa.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'k_pendidikan_psp',
              label: 'Pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'm_kualifikasi.data.keterangan') || '-',
            },
            {
              key: 'pendidikan_instansi',
              label: 'Nama instansi pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'pendidikan_instansi') || '-',
            },
          ],
          [
            {
              key: 'k_pendidikan_bidang_psp',
              label: 'Bidang Pendidikan Terakhir',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_pendidikan_bidang.data.keterangan') || '-',
            },
            {
              key: 'pendidikan_jurusan',
              label: 'Jurusan',
              value: this.$getDeepObj(this.profil, 'pendidikan_jurusan') || '-',
            },
          ],
        ],
      };
    },

    dokumens() {
      return [
        {
          id: 'ktp',
          component: 'Info',
          form: 'FormInput',
          label: 'KTP',
          title: 'KTP',
          pesan: [
            '<b>Catatan:</b><br />',
            '<ol>',
            '<li>Pastikan <strong>Nama</strong> pada KTP yang diunggah sesuai dengan Nama Anda</li>',
            `<li>Pastikan <strong>NIK</strong> pada KTP yang diunggah sesuai dengan data NIK yang Anda isikan ${
              this.$getDeepObj(this.profil, 'nik')
                ? `<strong>(${this.$getDeepObj(this.profil, 'nik')})</strong>`
                : 'di Form CV - Informasi Umum'
            }</li>`,
            '<li>Pastikan Kualitas KTP Anda Jelas (tidak blur)</li>',
            '<li>Pastikan Tampilan KTP Anda tidak terbalik untuk memudahkan verifikasi</li>',
            '</ol>',
          ].join(''),
        },
        {
          id: 'pernyataan',
          component: 'Info',
          form: 'FormInput',
          label: 'Surat Pernyataan Dukungan Dinas Pendidikan / Atasan',
          title: 'Surat Pernyataan Dukungan Dinas Pendidikan / Atasan',
          pesan: `Pastikan Anda mengunduh 
                  <a style="font-weight: bold" href="https://files1.simpkb.id/berkas/sekolah-penggerak/Surat-Pernyataan-Dukungan-SP-Angkatan-3.docx" target="_blank">template dokumen ini</a>, 
                  kemudian anda print, isi lalu anda scan, dan unggah di sini dalam format PDF`,
          // optional: true,
        },
        {
          id: 'pakta',
          component: 'Info',
          form: 'FormInput',
          label: 'Pakta Integritas',
          title: 'Pakta Integritas',
          pesan: `Pastikan pakta integritas yang Anda kirimkan sesuai dengan 
                  <a style="font-weight: bold" href="${process.env.VUE_APP_API_URL +
                    '/psp/gtk/peserta-ajuan/template-pakta'}" target="_blank">template dokumen ini</a>`,
          // optional: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions('preferensi', ['getPreferensi']),

    ...mapActions('cv', ['kirim', 'batalKirim', 'ajuan']),

    getData(type) {
      const diklat = this.$getDeepObj(this.profil, 'psp_profil_diklats.data') ?? [];
      const organisasi = this.$getDeepObj(this.profil, 'psp_profil_organisasis.data') ?? [];
      const program = this.$getDeepObj(this.profil, 'psp_profil_programs.data') ?? [];
      const prestasi = this.$getDeepObj(this.profil, 'psp_profil_prestasis.data') ?? [];
      const komunitas = this.$getDeepObj(this.profil, 'psp_profil_komunitases.data') ?? [];
      const hobi = this.$getDeepObj(this.profil, 'psp_profil_hobis.data') ?? [];

      const formData = {
        dasar: {
          nama: this.$getDeepObj(this.profil, 'ptk.data.nama') || '',
          kelamin: this.$getDeepObj(this.profil, 'ptk.data.kelamin') || '',
          no_ukg: this.$getDeepObj(this.profil, 'ptk.data.no_ukg') || '',
          nik: this.$getDeepObj(this.profil, 'nik') || '',
          no_wa: this.$getDeepObj(this.profil, 'no_wa') || '',
          email: this.$getDeepObj(this.profil, 'ptk.data.alt_email') || '',
          k_kota: this.$getDeepObj(this.profil, 'k_kota') || '',
          k_propinsi: this.$getDeepObj(this.profil, 'k_propinsi') || '',
          alamat: this.$getDeepObj(this.profil, 'alamat') || '',
          tmp_lahir: this.$getDeepObj(this.profil, 'ptk.data.tmp_lahir') || '',
          tgl_lahir: this.$getDeepObj(this.profil, 'ptk.data.tgl_lahir') || null,
          sekolah_id: `
              ${this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.nama')} (${this.$getDeepObj(
            this.profil,
            'ptk.data.ptk_sekolah.data.sekolah.data.npsn'
          )})
              `.trim(),
          jenjang:
            this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.m_jenjang.data.singkat') || null,
          npsn: this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.npsn') || null,
          tugas_id: [
            this.$getDeepObj(this.profil, 'm_tugas.data.keterangan'),
            `${this.$getDeepObj(this.profil, 'sekolah.data.nama')} (${this.$getDeepObj(
              this.profil,
              'sekolah.data.npsn'
            )})
            `,
          ]
            .join(' pada ')
            .trim(),
          k_kasek_lama_psp: this.$getDeepObj(this.profil, 'k_kasek_lama_psp') || null,
          k_kasek_sisa_psp: this.$getDeepObj(this.profil, 'k_kasek_sisa_psp') || null,
          kualifikasi: this.$getDeepObj(this.profil, 'm_kualifikasi.data.keterangan') || null,
          pendidikan_instansi: this.$getDeepObj(this.profil, 'pendidikan_instansi') || null,
          k_pendidikan_bidang_psp: this.$getDeepObj(this.profil, 'k_pendidikan_bidang_psp') || null,
          pendidikan_jurusan: this.$getDeepObj(this.profil, 'pendidikan_jurusan') || null,
          alamat_ktp_dapodik: [
            `${this.$getDeepObj(this.profil, 'ptk.data.ptk_info_dapodik.data.alamat_jalan')}`,
            `${this.$getDeepObj(this.profil, 'ptk.data.ptk_info_dapodik.data.rt')}`,
            `${this.$getDeepObj(this.profil, 'ptk.data.ptk_info_dapodik.data.rw')}`,
          ].join(', '),
          k_propinsi_dapodik: this.$getDeepObj(this.profil, 'ptk.data.k_propinsi') || null,
          k_kota_dapodik: this.$getDeepObj(this.profil, 'ptk.data.k_kota') || null,
          k_propinsi_sekolah_dapodik:
            this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.k_propinsi') || null,
          k_kota_sekolah_dapodik:
            this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.k_kota') || null,
        },
        diklat,
        organisasi,
        program,
        prestasi,
        komunitas,
        hobi,
      };
      return formData[type];
    },

    mapParam(params, type) {
      const mapped = {
        dasar: {
          alt_email: params['email'],
          nik: params['nik'],
          no_wa: params['no_wa'],
          k_kota: params['k_kota'],
          k_propinsi: params['k_propinsi'],
          alamat: params['alamat'],
          k_kasek_lama_psp: params['k_kasek_lama_psp'],
          k_kasek_sisa_psp: params['k_kasek_sisa_psp'],
          // k_pendidikan_psp: params['k_pendidikan_psp'],
          pendidikan_instansi: params['pendidikan_instansi'],
          k_pendidikan_bidang_psp: params['k_pendidikan_bidang_psp'],
          pendidikan_jurusan: params['pendidikan_jurusan'],
        },
        diklat: { diklats: params },
        organisasi: { organisasis: params },
        program: { programs: params },
        prestasi: { prestasis: params },
        komunitas: { komunitases: params },
        kontak: { kontaks: params },
        hobi: { hobis: params },
      };

      return mapped[type];
    },

    onAjuan() {
      if (this.isTutupAjuan && this.isTutupPerbaikan) {
        this.$info(`${this.isPerbaikan ? 'Ajuan Perbaikan Berkas' : 'Ajuan CV'} Guru Penggerak telah ditutup.`);
        return;
      }

      this.$confirm(`<h3>Anda yakin ingin mengajukan Perbaikan Berkas sekarang?</h3>`, `Ajuan Perbaikan`, {
        tipe: 'success',
      }).then(() => {
        this.ajuan({
          id: this.id,
          tipe: '',
        }).then(() => {
          this.$success(`Data Perbaikan Anda berhasil diajukan`);
          this.onReload(true);
          this.getPreferensi(true);
        });
      });
    },

    onSaveAjuan() {
      const id = this.$getDeepObj(this.gpmFungsi, 'gpm_guru_fungsi_id');
      const jenis = 'cv';

      this.kirim({ id, jenis }).then(() => {
        this.getPreferensi(true);
        this.$success(`CV Anda berhasil dikirim`);
        this.$router.push({ name: 'home' });
      });
    },

    onBatalAjuan() {
      if (this.isTutupAjuan) {
        const msg = `<p class="title mb-2">Mohon maaf! Pendaftaran Calon ${this.jenisCalon} telah ditutup`;
        this.$info(msg, `Perubahan data tidak diperbolehkan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      const id = this.$getDeepObj(this.gpmFungsi, 'gpm_guru_fungsi_id');
      const jenis = 'cv';

      this.$confirm(`Anda yakin ingin membatalkan Ajuan CV Anda?`, `Batal Ajuan CV`, {
        tipe: 'error',
      }).then(() => {
        this.batalKirim({ id, jenis }).then(() => {
          this.$success(`Ajuan CV berhasil dibatalkan`);
          this.onReload(true);
          this.getPreferensi(true);
        });
      });
    },

    setDurasi() {
      const end = this.$getDeepObj(this.gpmFungsi, 'wkt_mulai_cv');

      // set current tab if is_revisi
      if (this.isRevisi || (this.isPerbaikan && this.isKandidat)) {
        this.tab = 5;
      }

      if (end) {
        let result = '';
        const x = setInterval(() => {
          // Find the distance between now and the count down date
          const distance = new Date(end).getTime() + 86400000 - new Date().getTime();

          // Time calculations for days, hours, minutes and seconds
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (seconds < 0) {
            result = 'Telah habis';
          } else {
            result = 'Tersisa';
          }

          // Append Output result
          result += days > 0 ? ` ${days} hari` : '';
          result += hours > 0 ? ` ${hours} jam` : '';
          result += minutes > 0 ? ` ${minutes} menit` : '';
          result += seconds > 0 && hours === 0 ? ` ${seconds} detik` : '';

          this.durasi = result;
          // If the count down is over, write some text
          if (distance < 0) {
            this.durasi = result;
            clearInterval(x);
          }
        }, 1000);
      }
    },
  },
  watch: {
    gpmFungsi: 'setDurasi',
  },
};
